import { MUserProfile } from '../../../models/client/profile.model'
import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    profile: MUserProfile,
}

const ProfileReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_PROFILE:
            return {
                ...state,
                profile: action.payload,
            }

        default:
            return { ...state }
    }
}

export default ProfileReducer
